import axios from "axios";

/**
 * Function to send API requests using axios
 * @param {string} api_name - The API endpoint (relative to base URL)
 * @param {object} params - The request parameters or data
 * @param {string} method - The HTTP method (GET, POST, PUT, DELETE)
 * @returns {Promise} - A Promise that resolves to the API response
 */
export async function sendApiRequest(api_name, params = {}, method = "GET") {
  axios.defaults.withCredentials = true;
  const url = `${process.env.REACT_APP_BASE_URL}/${api_name}`;

  try {
    const token = localStorage.getItem("tokenData");

    const options = {
      url: url,
      method: method.toUpperCase(),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    if (method.toUpperCase() === "GET" || method.toUpperCase() === "DELETE") {
      options.params = params;
    } else {
      options.data = params;
    }

    const response = await axios(options);
    return response;
  } catch (error) {
    return { message: error.response.data.message, status: false };
  }
}

/**
 * Function to send WhatsApp notification
 * @param {string} message - The message to send
 * @returns {Promise} - A Promise that resolves to the API response
 */
export async function sendWhatsAppNotification(message) {
  try {
    const response = await sendApiRequest('api/notifications/whatsapp', {
      message,
      // The admin's WhatsApp number should be configured in the backend
    }, 'POST');
    return response;
  } catch (error) {
    console.error('WhatsApp notification error:', error);
    throw error;
  }
}
